<template>
	<div class="life-stage-circles">
		<!-- One circle per life stage. Read-only (a span) everywhere the stage
		     set is reference data; a button on the district's product, where it
		     toggles the district's own selection and auto-saves. -->
		<component
			:is="editable ? 'button' : 'span'"
			v-for="target in LIFE_STAGE_TARGETS"
			:key="target.code"
			class="target-icon"
			:class="[
				active.has(target.code) ? 'target-active' : 'target-inactive',
				editable ? 'target-editable' : '',
			]"
			:type="editable ? 'button' : undefined"
			:title="editable ? `${target.title} — click to toggle` : target.title"
			@click="editable ? emit('toggle', target.code) : undefined"
		>
			{{ target.code }}
		</component>
	</div>
</template>

<script setup lang="ts">
import { LIFE_STAGE_TARGETS } from "@/view/configuration/pesticideCatalog";

withDefaults(
	defineProps<{
		active: Set<string>;
		/** District mode: the circles toggle instead of only showing. */
		editable?: boolean;
	}>(),
	{ editable: false },
);

const emit = defineEmits<{ (e: "toggle", code: string): void }>();
</script>

<style scoped>
.life-stage-circles {
	display: inline-flex;
	gap: 2px;
}

.target-icon {
	display: inline-block;
	width: 24px;
	height: 24px;
	text-align: center;
	line-height: 24px;
	border-radius: 50%;
	font-size: 12px;
	font-weight: bold;
	color: white;
}

.target-active {
	background-color: #0d6efd;
}

.target-inactive {
	background-color: #dee2e6;
	color: #6c757d;
}

button.target-icon {
	padding: 0;
	border: 0;
}

.target-editable {
	cursor: pointer;
}

.target-editable:hover {
	outline: 2px solid rgba(13, 110, 253, 0.35);
}
</style>
